import React, { useMemo, useState } from 'react';

const IncidentEditForm = ({
  incidentData,
  handleInputChange,
  loadingStatuses,
  statuses,
  statusId,
  setStatusId,
  loadingPriorities,
  priorities,
  priorityId,
  setPriorityId,
  loadingUsers,
  users,
  assignedTo,
  setAssignedTo,
  navigate,
  editId,
  handleCreateIncident,
  isSubmitting,
}) => {
  const [activeSection, setActiveSection] = useState('gestion');

  const sections = useMemo(
    () => [
      { id: 'resumen', title: 'Resumen' },
      { id: 'gestion', title: 'Gestión' },
      { id: 'asignacion', title: 'Asignación' },
    ],
    []
  );

  return (
    <div className="edit-form-v2">
      <aside className="edit-side-nav">
        {sections.map((section) => (
          <button
            key={section.id}
            type="button"
            className={`edit-side-nav-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => setActiveSection(section.id)}
          >
            {section.title}
          </button>
        ))}
      </aside>

      <div className="edit-sections">
        <section className={`edit-section-card ${activeSection === 'resumen' ? 'active' : ''}`}>
          <button type="button" className="edit-section-title" onClick={() => setActiveSection('resumen')}>
            Título y descripción
          </button>
          {activeSection === 'resumen' && (
            <div className="edit-section-content">
              <div className="form-group">
                <label htmlFor="edit-title">Título</label>
                <textarea
                  id="edit-title"
                  value={incidentData.title || ''}
                  onChange={(e) => handleInputChange('title', e.target.value)}
                  placeholder="Ingrese un título del caso"
                  rows="1"
                />
              </div>

              <div className="form-group">
                <label htmlFor="edit-description">Descripción</label>
                <textarea
                  id="edit-description"
                  value={incidentData.description || ''}
                  onChange={(e) => handleInputChange('description', e.target.value)}
                  placeholder="Ingrese una descripción del caso"
                  rows="4"
                />
              </div>
            </div>
          )}
        </section>

        <section className={`edit-section-card ${activeSection === 'gestion' ? 'active' : ''}`}>
          <button type="button" className="edit-section-title" onClick={() => setActiveSection('gestion')}>
            Estado y prioridad
          </button>
          {activeSection === 'gestion' && (
            <div className="edit-section-content">
              <div className="form-group">
                <label htmlFor="status">Estado de la tarea</label>
                {loadingStatuses ? (
                  <div className="field-loading">Cargando estados...</div>
                ) : (
                  <select id="status" value={statusId || ''} onChange={(e) => setStatusId(e.target.value || null)}>
                    <option value="">Seleccione un estado</option>
                    {Array.isArray(statuses) && statuses.map((status) => (
                      <option key={status.id} value={status.id}>
                        {status.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="priority">Prioridad</label>
                {loadingPriorities ? (
                  <div className="field-loading">Cargando prioridades...</div>
                ) : (
                  <select id="priority" value={priorityId || ''} onChange={(e) => setPriorityId(e.target.value || null)}>
                    <option value="">Seleccione una prioridad</option>
                    {Array.isArray(priorities) && priorities.map((priority) => (
                      <option key={priority.id} value={priority.id}>
                        {priority.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>
          )}
        </section>

        <section className={`edit-section-card ${activeSection === 'asignacion' ? 'active' : ''}`}>
          <button type="button" className="edit-section-title" onClick={() => setActiveSection('asignacion')}>
            Responsable
          </button>
          {activeSection === 'asignacion' && (
            <div className="edit-section-content">
              <div className="form-group">
                <label htmlFor="edit-assigned_to">Responsable a cargo</label>
                {loadingUsers ? (
                  <div className="field-loading">Cargando usuarios...</div>
                ) : (
                  <select id="edit-assigned_to" value={assignedTo || ''} onChange={(e) => setAssignedTo(e.target.value || null)}>
                    <option value="">Seleccione un responsable</option>
                    {Array.isArray(users) && users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.first_name} {user.last_name} {user.email ? `(${user.email})` : ''}
                      </option>
                    ))}
                  </select>
                )}
                <p className="field-help">Solo usuarios de grupos asociados al proyecto del formulario.</p>
              </div>
            </div>
          )}
        </section>

        <div className="form-actions edit-actions-sticky">
          <button type="button" className="btn btn-secondary" onClick={() => navigate(`/admin/questions/task/incidentes/${editId}`)}>
            Cancelar
          </button>
          <button type="button" className="btn btn-success" onClick={handleCreateIncident} disabled={isSubmitting || !statusId}>
            {isSubmitting ? 'Actualizando...' : 'Guardar cambios'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncidentEditForm;
